import { __extends } from 'tslib';
import classNames from 'classnames';
import * as React from 'react';
import Highlight from 'react-highlighter';
import ClanTag from '../ClanTag/ClanTag.js';
import styles from './ClanName.module.scss.js';

var ClanName = (function (_super) {
    __extends(ClanName, _super);
    function ClanName() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClanName.prototype.renderTeamNumber = function () {
        if (this.props.teamName && !this.props.isBrawl) {
            return React.createElement("span", { className: styles.teamName },
                this.props.teamName,
                "\u00A0");
        }
        return '';
    };
    ClanName.prototype.render = function () {
        var MAX_LENGTH = 40;
        var name = this.props.clanName.length < MAX_LENGTH
            ? this.props.clanName
            : this.props.clanName.slice(0, MAX_LENGTH) + "...";
        var clanName = this.props.highlight ? (React.createElement(Highlight, { search: this.props.highlight, matchElement: "span" }, name)) : (name);
        return (React.createElement("div", { className: classNames(styles.container, this.props.className) },
            this.renderTeamNumber(),
            React.createElement(ClanTag, { clanTag: this.props.clanTag, clanColor: this.props.clanColor, highlight: this.props.highlight }),
            "\u00A0",
            React.createElement("span", { className: styles.clanName }, clanName)));
    };
    return ClanName;
}(React.PureComponent));

export { ClanName as default };
//# sourceMappingURL=ClanName.js.map
